/**
 * Vista: Lista de Reportes de Garantía
 * Formato: AMX-PVTA-FR-06
 */

import posventaService from '../services/posventa.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import modal from '../utils/modal.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Reportes de Garantía</h2>
          ${permisos.canCreate('garantias') ? `<button class="btn btn-primary" onclick="router.navigate('/posventa/reportes-garantia/nuevo')">
            + Nuevo Reporte
          </button>` : ''}
        </div>

        <!-- Estadísticas -->
        <div id="statsContainer" class="stats-container" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statTotal" style="font-size: 1.5rem; font-weight: bold;">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Total Reportes</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statAbiertos" style="font-size: 1.5rem; font-weight: bold; color: var(--warning);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Abiertos</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statValidas" style="font-size: 1.5rem; font-weight: bold; color: var(--success);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Válidas</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statNulas" style="font-size: 1.5rem; font-weight: bold; color: var(--danger);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Nulas</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input
              type="text"
              id="busqueda"
              class="form-input"
              placeholder="Num. Serie, Usuario..."
            />
          </div>

          <div class="form-group">
            <label class="form-label">Dictamen</label>
            <select id="dictamenFilter" class="form-input">
              <option value="">Todos</option>
              <option value="pendiente">Pendiente</option>
              <option value="valida">Válida</option>
              <option value="nula">Nula</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Estado</label>
            <select id="estadoFilter" class="form-input">
              <option value="">Todos</option>
              <option value="abierto">Abierto</option>
              <option value="cerrado">Cerrado</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Desde</label>
            <input type="date" id="fechaDesde" class="form-input" />
          </div>

          <div class="form-group">
            <label class="form-label">Hasta</label>
            <input type="date" id="fechaHasta" class="form-input" />
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.reportesGarantiaListView.limpiarFiltros()" style="width: 100%;">
              Limpiar Filtros
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 30px;"></th>
                <th>Fecha</th>
                <th>NS</th>
                <th class="tbl-hide-mobile">Usuario</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Hr Op.</th>
                <th class="tbl-hide-mobile">Dictamen</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="reportesTableBody">
              <tr>
                <td colspan="9" style="text-align: center; padding: 2rem;">
                  Cargando reportes...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('garantias')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.reportesGarantiaListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    // Event listeners
    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarReportes();
      }, 500);
    });

    document.getElementById('dictamenFilter').addEventListener('change', (e) => {
      if (e.target.value === '') {
        delete this.filters.dictamen;
      } else {
        this.filters.dictamen = e.target.value;
      }
      this.currentPage = 1;
      this.cargarReportes();
    });

    document.getElementById('estadoFilter').addEventListener('change', (e) => {
      if (e.target.value === '') {
        delete this.filters.estado;
      } else {
        this.filters.estado = e.target.value;
      }
      this.currentPage = 1;
      this.cargarReportes();
    });

    document.getElementById('fechaDesde').addEventListener('change', (e) => {
      this.filters.fecha_desde = e.target.value;
      this.currentPage = 1;
      this.cargarReportes();
    });

    document.getElementById('fechaHasta').addEventListener('change', (e) => {
      this.filters.fecha_hasta = e.target.value;
      this.currentPage = 1;
      this.cargarReportes();
    });

    await this.cargarEstadisticas();
    await this.cargarReportes();
  },

  async cargarEstadisticas() {
    try {
      const response = await posventaService.obtenerEstadisticas();
      const stats = response.data || response;

      document.getElementById('statTotal').textContent = stats.reportes_garantia?.total || 0;
      document.getElementById('statAbiertos').textContent = stats.reportes_garantia?.abiertos || 0;
      document.getElementById('statValidas').textContent = stats.reportes_garantia?.validas || 0;
      document.getElementById('statNulas').textContent = stats.reportes_garantia?.nulas || 0;
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarReportes() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const response = await posventaService.listarReportesGarantia(params);
      const reportes = Array.isArray(response.data) ? response.data : [];
      const pagination = response.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderReportes(reportes);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar reportes');
      console.error('Error:', error);
      this.renderReportes([]);
    }
  },

  renderReportes(reportes) {
    const tbody = document.getElementById('reportesTableBody');

    if (!reportes || reportes.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="9" style="text-align: center; padding: 2rem;">
            No se encontraron reportes de garantía
          </td>
        </tr>
      `;
      return;
    }

    const fechaFmt = (f) => f ? new Date(f).toLocaleDateString('es-MX') : '-';
    const dictamenBadge = (r) => {
      const badge = this.getDictamenBadge(r.dictamen);
      const label = r.dictamen ? r.dictamen.charAt(0).toUpperCase() + r.dictamen.slice(1) : 'Pendiente';
      return `<span class="badge ${badge}">${label}</span>`;
    };
    const estadoBadge = (r) => `<span class="badge ${r.completada ? 'badge-success' : 'badge-warning'}">${r.completada ? 'Completado' : 'Abierto'}</span>`;

    tbody.innerHTML = reportes.map(r => `
      <tr>
        <td>
          <button class="tbl-expand-btn" onclick="window.reportesGarantiaListView.toggleRow(${r.id})">&#9654;</button>
        </td>
        <td>${fechaFmt(r.fecha_reporte)}</td>
        <td><strong>${r.num_serie}</strong></td>
        <td class="tbl-hide-mobile">${r.usuario || '-'}</td>
        <td class="tbl-hide-mobile">${r.modelo || '-'} (${r.marca || '-'})</td>
        <td class="tbl-hide-mobile">${r.hr_operacion != null ? r.hr_operacion : '-'}</td>
        <td class="tbl-hide-mobile">${dictamenBadge(r)}</td>
        <td class="tbl-hide-mobile">${estadoBadge(r)}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">
            ${r.completada
              ? `${permisos.canView('garantias') ? `<button class="btn btn-sm btn-primary" onclick="window.reportesGarantiaListView.verDetalle(${r.id})">Ver</button>` : ''}`
              : `${permisos.canEdit('garantias') ? `<button class="btn btn-sm btn-primary" onclick="window.reportesGarantiaListView.verDetalle(${r.id})">Editar</button>` : ''}
                 ${permisos.canDelete('garantias') ? `<button class="btn btn-sm btn-danger" onclick="window.reportesGarantiaListView.eliminarReporte(${r.id})">Eliminar</button>` : ''}`
            }
          </div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-rg-${r.id}">
        <td colspan="9" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${fechaFmt(r.fecha_reporte)}</dd>
            <dt>Usuario</dt><dd>${r.usuario || '-'}</dd>
            <dt>NS</dt><dd>${r.num_serie}</dd>
            <dt>Modelo</dt><dd>${r.modelo || '-'} (${r.marca || '-'})</dd>
            <dt>Hr Op.</dt><dd>${r.hr_operacion != null ? r.hr_operacion + ' hrs' : '-'}</dd>
            <dt>Distribuidor</dt><dd>${r.distribuidor || '-'}</dd>
            <dt>Dictamen</dt><dd>${dictamenBadge(r)}</dd>
            <dt>Estado</dt><dd>${estadoBadge(r)}</dd>
            <dt>Problema</dt><dd style="white-space: pre-wrap;">${r.descripcion_problema ? r.descripcion_problema.substring(0, 100) + (r.descripcion_problema.length > 100 ? '...' : '') : '-'}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">
            ${r.completada
              ? `${permisos.canView('garantias') ? `<button class="btn btn-sm btn-primary" onclick="window.reportesGarantiaListView.verDetalle(${r.id})">Ver</button>` : ''}`
              : `${permisos.canEdit('garantias') ? `<button class="btn btn-sm btn-primary" onclick="window.reportesGarantiaListView.verDetalle(${r.id})">Editar</button>` : ''}
                 ${permisos.canDelete('garantias') ? `<button class="btn btn-sm btn-danger" onclick="window.reportesGarantiaListView.eliminarReporte(${r.id})">Eliminar</button>` : ''}`
            }
          </div>
        </td>
      </tr>
    `).join('');
  },

  getDictamenBadge(dictamen) {
    if (dictamen === 'valida') return 'badge-success';
    if (dictamen === 'nula') return 'badge-danger';
    return 'badge-secondary';
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center; align-items: center;">';

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.reportesGarantiaListView.cambiarPagina(${page - 1})"
        ${page === 1 ? 'disabled' : ''}
      >
        Anterior
      </button>
    `;

    for (let i = 1; i <= totalPages; i++) {
      if (i === page) {
        html += `<button class="btn btn-sm btn-primary" disabled>${i}</button>`;
      } else if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        html += `
          <button
            class="btn btn-sm btn-secondary"
            onclick="window.reportesGarantiaListView.cambiarPagina(${i})"
          >
            ${i}
          </button>
        `;
      } else if (i === page - 3 || i === page + 3) {
        html += '<span>...</span>';
      }
    }

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.reportesGarantiaListView.cambiarPagina(${page + 1})"
        ${page === totalPages ? 'disabled' : ''}
      >
        Siguiente
      </button>
    `;

    html += '</div>';
    container.innerHTML = html;
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarReportes();
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('dictamenFilter').value = '';
    document.getElementById('estadoFilter').value = '';
    document.getElementById('fechaDesde').value = '';
    document.getElementById('fechaHasta').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarReportes();
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-rg-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  verDetalle(id) {
    router.navigate(`/posventa/reportes-garantia/${id}`);
  },

  async eliminarReporte(id) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar este reporte de garantía? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await posventaService.eliminarReporteGarantia(id);
          toast.success('Reporte eliminado');
          this.cargarEstadisticas();
          this.cargarReportes();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar');
        }
      }
    );
  }
};
